import axios from "axios";

const HOST_API = process.env.REACT_APP_URL;

// Los endpoints de liquidación mensual validan el rol server-side leyendo el
// JWT del header Authorization (no hay interceptor global que lo adjunte
// hoy en la app), por eso se manda explícitamente acá.
const authHeaders = () => {
  const token = JSON.parse(localStorage.getItem('user') || '{}').token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getLiquidacionMensual = (administracionId, periodo) =>
  axios.get(`${HOST_API}api/liquidacionMensual/GetLiquidacion`, {
    params: { administracionId, periodo },
    headers: authHeaders(),
  });

export const saveMontoPorUF = (payload) =>
  axios.post(`${HOST_API}api/liquidacionMensual/SaveMontoPorUF`, payload, {
    headers: authHeaders(),
  });
